import React from 'react';
export function About() {
  return <section id="אודות" className="py-24 bg-black text-white overflow-hidden relative" data-id="element-12">
      <div className="absolute top-0 left-0 w-full h-4 bg-acid animate-glitch" data-id="element-13"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-14">
        <div className="max-w-4xl mx-auto text-center" data-id="element-15">
          <h2 className="text-5xl md:text-7xl font-black mb-12 leading-tight" data-id="element-16">
            אנחנו לא{' '}
            <span className="bg-magenta text-black px-2 brutal-border inline-block -rotate-2" data-id="element-17">
              עוד מותג
            </span>
            .<br data-id="element-18" />
            אנחנו{' '}
            <span className="bg-acid text-black px-2 brutal-border inline-block rotate-2" data-id="element-19">
              תנועה
            </span>
            .
          </h2>

          <p className="text-2xl md:text-3xl font-bold leading-relaxed mb-12" data-id="element-20">
            נולדנו ברחובות תל אביב, מתוך הרעש, הכאוס והאנרגיה שלא עוצרת. הבגדים
            שלנו הם לא רק בד, הם <span className="text-electric" data-id="element-21">הצהרה</span>.
            אנחנו שוברים את החוקים כדי שאתה תוכל לכתוב אותם מחדש.
          </p>

          <div className="inline-block" data-id="element-22">
            <button className="brutal-btn bg-white text-black text-2xl px-12 py-4 hover:bg-electric hover:text-white" data-id="element-23">
              קרא את המניפסט
            </button>
          </div>
        </div>
      </div>

      {/* Decorative elements */}
      <div className="absolute -bottom-20 -right-20 w-64 h-64 bg-magenta rounded-full blur-3xl opacity-20" data-id="element-24"></div>
      <div className="absolute top-20 -left-20 w-64 h-64 bg-electric rounded-full blur-3xl opacity-20" data-id="element-25"></div>
    </section>;
}